export var ApiNotificationResourceType;
(function (ApiNotificationResourceType) {
    ApiNotificationResourceType["DashboardComments"] = "dashboardComments";
    ApiNotificationResourceType["AiReview"] = "aiReview";
})(ApiNotificationResourceType || (ApiNotificationResourceType = {}));
//# sourceMappingURL=notifications.js.map